export default class answerModel {
    constructor({id, answer, answer_type, language, score, is_active, created_by_name}){
        this.id = id;
        this.answer = answer;
        this.answer_type = answer_type;
        this.score = score;
        this.status = is_active;
        this.language = language
        this.created_by_name = created_by_name
    }
}